import styled from 'styled-components'
import { TableTdGrid } from '../../style/table/td/index.styled'
import { colorTheme } from '../../../../../style/theme/colorTheme'

export const PreOrderWrapper = styled(TableTdGrid)`
	row-gap: 0;

	> svg {
		grid-row: 1 / 3;
	}

	> div {
		font-size: 0.8em;

		&:nth-child(2) {
			grid-column: 2;
			grid-row: 1;
		}

		&:nth-child(3) {
			grid-column: 2;
			grid-row: 2;
		}
	}
`
PreOrderWrapper.displayName = 'PreOrderWrapper'

export const MarkReadyWaitingWrapper = styled(TableTdGrid)`
	row-gap: 0;
`
MarkReadyWaitingWrapper.displayName = 'MarkReadyWaitingWrapper'

export const StatusTextWrapper = styled.div`
	display: flex;
	align-items: center;
	gap: 0.35em;
`
StatusTextWrapper.displayName = 'StatusTextWrapper'

export const CancellationLabel = styled.div`
	margin-top: 0.2em;

	> div {
		color: ${colorTheme.orders.table.cancellationMark};
		font-size: 0.75em;
		white-space: nowrap;

		.disabledStatus & {
			color: inherit;
		}
	}
`
CancellationLabel.displayName = 'CancellationLabel'
